import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie'

const initialState = {
    tokenData: Cookies.get("token") ? JSON.parse(Cookies.get("token")) : null
}

const tokenSlice = createSlice({
    name: "tokenSlice",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.tokenData = action.payload;
            console.log("Setting token in cookie:", action.payload);
            Cookies.set("token", JSON.stringify(action.payload), {
                expires: 3
            });
            return state;
        },
        removeToken: (state, action) => {
            state.tokenData = null;
            Cookies.remove("token");
            return state;
        }
    }

});

export const { setToken, removeToken } = tokenSlice.actions;
export default tokenSlice;